import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import BabyProfileForm from '../../components/baby-profile/BabyProfileForm';
import { useBabyProfiles } from '../../contexts/BabyProfileContext';
import PlanLimitExceededMessage from '../../components/common/PlanLimitExceededMessage';

// Styled Components
const PageContainer = styled.div`
  background-color: var(--light);
  padding: 2rem 0;
`;

const FormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  
  .back-link {
    color: var(--primary);
    text-decoration: none;
    display: flex;
    align-items: center;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const AddChild = () => {
  const navigate = useNavigate();
  const { refreshProfiles, hasReachedChildLimit, planLimitError, setPlanLimitError } = useBabyProfiles();
  const [showLimitError, setShowLimitError] = useState(false);

  // Check if user has reached the child limit
  useEffect(() => {
    if (hasReachedChildLimit()) {
      // Show error message instead of redirecting
      setShowLimitError(true);
    }
  }, [hasReachedChildLimit]);

  const handleSubmitSuccess = async () => {
    // Refresh profiles after successful creation
    await refreshProfiles();
    // Navigate to the dashboard
    navigate('/dashboard');
  };
  
  const handleCloseError = () => {
    setPlanLimitError(null);
    setShowLimitError(false);
    navigate('/dashboard');
  };

  // Create a mock error object for the frontend limit check
  const frontendLimitError = {
    message: "You've reached the maximum number of baby profiles allowed for your current plan.",
    currentCount: 2,
    maxAllowed: 2,
    plan: 'family'
  };

  return (
    <PageContainer>
      <div className="container">
        <FormHeader>
          <Link to="/dashboard" className="back-link">
            <i className="fas fa-arrow-left me-2"></i> Back to Dashboard
          </Link>
        </FormHeader>
        
        {/* Show error message if plan limit is reached */}
        {(planLimitError || showLimitError) && (
          <PlanLimitExceededMessage 
            error={planLimitError || frontendLimitError} 
            onClose={handleCloseError} 
          />
        )}
        
        {/* Only show the form if the limit is not reached */}
        {!showLimitError && !planLimitError && (
          <BabyProfileForm 
            onSubmitSuccess={handleSubmitSuccess}
            isEditing={false}
          />
        )}
      </div>
    </PageContainer>
  );
};

export default AddChild;
